import styled from "styled-components";

export const AddressRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
  font-family: ${(p) => p.theme.tokens.font.family};
  line-height: 1.4;
`;

export const PickupNote = styled.div`
  font-size: 13.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  font-family: ${(p) => p.theme.tokens.font.family};
`;
